/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment, useState, useContext, useEffect } from 'react';
import { Card, ProgressSteps, Table, AuthContext, useAPI } from 'components/lib';
import Astronauta from '../../../../assets/astronauta_4.svg';
import Style from './audience-campaign.module.scss';
import ReactPaginate from 'react-paginate';

const limit = 5;

// if (window.performance) {
//   if (performance.navigation.type == 1) {
//     window.location.href = window.location.origin + '/campaign';
//   }
// }

export function CampaignAudience(props){

  const listLeads = useAPI('/api/user/list-leads');
  // context
  const authContext = useContext(AuthContext);
  // const listLeads = authContext?.listLeads;

  // state
  const [leadList, setLeadList] = useState([]);
  const [leadListId, setLeadListId] = useState([]);
  const [leadListUpdated, setLeadListUpdated] = useState([]);
  const [pages, setPages] = useState(0);
  
  useEffect(() => {
    if(listLeads.data && listLeads.data && leadList.length === 0 && pages === 0) {
      let offset = Math.ceil(limit);
      let values = listLeads.data.slice(0, offset);
      setLeadList(values);
      setPages(1);
      setLeadListUpdated(listLeads.data);
    }
  }, [listLeads, leadList, pages]);

  const handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil((selected + 1) * limit);
    let values = offset < leadListUpdated.length ? leadListUpdated.slice(offset - (limit), offset) : leadListUpdated.slice(offset - (limit), leadListUpdated.length);
    setLeadList(values);
  };

  let pagesList = leadListUpdated?.length > 0 ? Math.ceil(leadListUpdated.length / limit) : 0;

  const selectListLead = (selected) => {
    const toggle = row => row.id === selected.id
      ? { ...row, check: row.check === 'checked' ? null : 'checked' }
      : row;
    setLeadListUpdated(rows => rows.map(toggle));
    setLeadList(rows => rows.map(toggle));
    setLeadListId(ids => ids.includes(selected.id)
      ? ids.filter(id => id !== selected.id)
      : [...ids, selected.id]);
  }

  return (
    <Fragment>
    
      <div style={{ marginTop: '-40px' }}>
        <ProgressSteps items={[
            { name: 'Crear', url: '/creation', completed: true },
            { name: 'Audiencia', url: '/audience', completed: true },
            { name: 'Plantillas', url: '/theme', completed: false },
            { name: 'Resumen', url: '/summary', completed: false },
            { name: 'Listo', url: '/finish', completed: false },
        ]} marginRight='-15px' shadow/>
      </div>

      <Card className={ Style.card }>
        <header>
          <h2>
            Selecciona una lista
          </h2>
        </header>

        <p>Selecciona la lista con la que realizarás tu campaña</p>

        <div style={{ marginTop: '2em' }}>
          {pagesList !== 0 &&
            <div 
                style={{
                    width: '100%', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    marginBottom: '1.5em'
                }}
            >
              <ReactPaginate
                  previousLabel={'Anterior'}
                  nextLabel={'Siguiente'}
                  breakLabel={'...'}
                  onPageChange={handlePageClick}
                  pageCount={pagesList}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  containerClassName={'pagination'}
                  activeClassName={'page-active'}
                  breakClassName={'break'}
                  breakLinkClassName={'dots'}
                  pageLinkClassName={'number'}
                  pageClassName={'page-number'}
                  nextClassName='next-page'
                  nextLinkClassName='next-page'
                  previousClassName='previous-page'
                  previousLinkClassName='previous-page'
              />
            </div>
          }
          <Table
            data={ leadList ? leadList : [] }
            hide={['_id', '__v', 'user_id', 'id', 'list', 'check', 'account']}
            loading={ listLeads && listLeads.data ? false : true }
            actions={{
                custom: [
                { icon: 'check_action', action: selectListLead }
                ],
            }}
          >
            
          </Table>
        </div>
      </Card>

      <div style={{ position: 'fixed', bottom: '2em', right: '2em' }}>
        <ProgressSteps items={[
          { name: 'Regresar', url: '/creation', completed: false, iconLeft: 'chevron-left' },
          { name: 'Continuar', url: '/theme', completed: true, iconRight: 'chevron-right', locked: leadListId.length === 0 ? true : false, click: () => authContext.dispatch({ type: 'ADD_CAMPAIGN', value: { leadListId } }) },
        ]} marginRight='10px'/>
      </div>

      <div className={ Style.logo }>
        <img width={350} height={350} src={ Astronauta } alt='Logo'/>
      </div>
      
    </Fragment>
  )
}
